export const SCOPA = '/scopa';
export const WIST = '/wist';
export const MTG = '/mtg';
export const LOGIN = '/login';
export const HOME = '/';
